import { Button } from "@mantine/core";
import RoutesInstance from "@routes/instances";
import { useMutation } from "@tanstack/react-query";
import Common from "@utilities/common";
import { Form, Formik } from "formik";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IFormData } from "./types";
import { Schema } from "./validations";
import UploadFile from "@components/public/uploadFile";

const FormContainer: FC = () => {
    const [initialValues] = useState<IFormData>({
        file: undefined,
    });

    const Navigate = useNavigate();

    const { mutate, isLoading } = useMutation(
        ({ file }: IFormData) =>
            Common.api.gallery.Create({
                file,
            }),
        {
            onSuccess: () => {
                Navigate(RoutesInstance.gallery);
            },
        },
    );

    const handleSubmit = async (values: IFormData) => {
        mutate(values);
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={Schema}
            validateOnBlur={true}
            validateOnChange={true}>
            {({ values, handleChange, errors, isValid }) => (
                <Form>
                    <div className="mb-4">
                        <UploadFile
                            type="image"
                            id="file"
                            name="file"
                            fileSetings={{
                                accept: "image/jpg,image/jpeg,image/webp,image/png",
                                aspectRatio: 4 / 3,
                                maximumSize: 32768000,
                            }}
                            repository="gallery"
                            inputProps={{
                                label: "فایل",
                                value: values.file?.name || "",
                                errors: errors.file,
                                placeholder: "فایل",
                                required: true,
                            }}
                            handleChange={({
                                result,
                            }: {
                                result?: { file?: string };
                            }) => {}}
                            callbackFunction={(file) =>
                                handleChange({
                                    target: {
                                        id: "file",
                                        name: "file",
                                        value: file,
                                    },
                                })
                            }
                        />
                    </div>

                    <div className="text-center">
                        <Button
                            variant="filled"
                            className="transition-all duration-300 px-16"
                            color="blue"
                            radius={9999}
                            type="submit"
                            disabled={!isValid || isLoading}
                            loading={isLoading}>
                            ثبت
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default FormContainer;
